import {NewProduct, ProductType} from '@domain/materials'

export const getNewFormProduct = (newFormProductType: ProductType): NewProduct => {
  return {
    id: null,
    code: null,
    name: null,
    type: newFormProductType
  }
}
